export const defaultServerUrl = "http://127.0.0.1:8888";
